// extracted by mini-css-extract-plugin
module.exports = {"settingsPane":"styles_settingsPane__3UjPF","settingsTabs":"styles_settingsTabs__2jMa4"};